import {
  PM_CONTRACT_START,
  PM_CONTRACT_END,
  PM_CONTRACT_BY_ID,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { toast as globalToast } from '../../../components/ToastManager';
import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../components/ExecutionLogHandler';

const PMTypes = (type, data) => ({ type, data });

export const getPriceManagementContract = (id) => {
  return (dispatch) => {
    dispatch(PMTypes(PM_CONTRACT_START));
    getPriceManagementContractAPI(id)
      .then((response) => {
        dispatch(PMTypes(PM_CONTRACT_BY_ID, response.data.response));
        dispatch(PMTypes(PM_CONTRACT_END));
      })
      .catch(() => dispatch(PMTypes(PM_CONTRACT_END)));
  };
};

const getPriceManagementContractAPI = (id) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.get(`/price-management/contract/${id}`, { headers });
};

export const submitPriceManagementContract = (type, id, data) => {
  return async (dispatch) => {
    dispatch(PMTypes(PM_CONTRACT_START));
    try {
      const response = await submitPriceManagementContractAPI(type, data);
      dispatch(PMTypes(PM_CONTRACT_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || response?.data?.response);
        return { success: true, response };
      }
    } catch (error) {
      dispatch(PMTypes(PM_CONTRACT_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError };
      }
      throw error;
    }
  };
};

const submitPriceManagementContractAPI = (type, data) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  if (type === 'edit') return axios.put('/price-management/contract', data, { headers });
  return axios.post('/price-management/contract', data, { headers });
};

export const deletePriceManagementContract = (id) => {
  return async (dispatch) => {
    dispatch(PMTypes(PM_CONTRACT_START));
    try {
      const response = await deletePriceManagementContractAPI(id);
      dispatch(PMTypes(PM_CONTRACT_END));

      const logNumber = response?.data?.log_number;
      if (logNumber) {
        const { hasError } = await handleExecutionLog(dispatch, logNumber);
        return { success: !hasError, response };
      } else {
        globalToast.showSuccess(response?.data?.message || 'Deleted successfully');
        return { success: true, response };
      }
    } catch (error) {
      dispatch(PMTypes(PM_CONTRACT_END));
      const logNumber = error.response?.data?.log_number;
      if (logNumber) await handleExecutionLog(dispatch, logNumber);
      throw error;
    }
  };
};

const deletePriceManagementContractAPI = (id) => {
  const headers = { Authorization: secureLocalStorage.getItem('aTk') };
  return axios.delete(`/price-management/contract/${id}`, { headers });
};
